// extracted by mini-css-extract-plugin
export default {"signInModal":"SignIn_signInModal__XnuO6","modalIcon":"SignIn_modalIcon__tciyW"};